"use client";

import ChatbotScript from "@/components/chatbot/ChatbotScript";
import AttributionCapture from "@/components/layout/AttributionCapture";
import FloatingWhatsAppButton from "@/components/utilities/FloatingWhatsAppButton";
import Clarity from "@/components/utilities/Clarity";

export default function ClientComponents() {
  return (
    <>
      <AttributionCapture />
      <Clarity />
      <ChatbotScript isEnabled={false} />
      <FloatingWhatsAppButton />
    </>
  );
}

